/* eslint-disable max-len */
import { get, has } from 'lodash';
import { calculateEnvironmentByHost } from '@cian/utils';
import { swapLatLng, getLkLink } from '../utils';
import { fetchUsersEnable } from '../../../../shared/repositories/chats/v1/users-enable/apiHelpers';

const environment = calculateEnvironmentByHost(window.location.host);

export default ($http, $q, httpApi) => {
  'ngInject';

  function lkResponseNormalizer(dataKey) {
    return function(res) {
      const error = get(res, 'data.' + dataKey + '.error');
      if (error) {
        return $q.reject(error);
      }

      const response = get(res, 'data.' + dataKey + '.response');
      if (response.code !== "Ok") {
        return $q.reject(response);
      }

      return response;
    };
  }

  return {
    enableChats: () => {
      return fetchUsersEnable({ httpApi }).then(({ statusCode }) => {
        if (statusCode === 400) {
          return Promise.reject();
        }

        return Promise.resolve();
      });
    },
    // http://swagger.dev.cian.ru/?url=http://www.master.dev.cian.ru/swagger/addform_common.json#!/draft/get_addform_v2_drafts
    getDraft: (params, config = {}) => {
      config.params = params;
      return $http.get('drafts/', config);
    },

    // http://swagger.dev.cian.ru/?url=http://www.master.dev.cian.ru/swagger/addform_common.json#!/draft/post_addform_v2_drafts
    postDraft: data => {
      return $http.post('drafts/', data, { allowServerErrors: true });
    },

    // http://swagger.dev.cian.ru/?url=http://www.master.dev.cian.ru/swagger/addform_common.json#!/draft/delete_addform_v2_drafts
    deleteDraft: guid => {
      return $http.delete('drafts/', { data: { objectGuid: guid } }, { allowServerErrors: true });
    },

    // http://swagger.dev.cian.ru/?url=http://www.master.dev.cian.ru/swagger/addform_common.json#!/draft/get_addform_v2_drafts_settings
    getDraftSettings: () => {
      return $http.get('drafts/settings/', { allowServerErrors: true })
        .then(response => response.data);
    },

    // http://swagger.dev.cian.ru/?url=http://www.master.dev.cian.ru/swagger/addform_common.json#!/draft/post_addform_v2_drafts_settings
    postDraftSettings: data => {
      return $http.post('drafts/settings/', data, { allowServerErrors: true });
    },

    // http://swagger.dev.cian.ru/?url=http://master.dev.cian.ru/swagger/addform_common.json#!/bs95centers/get_addform_v2_bs_center_id_default_photo
    getBsPhoto: (bsId) => {
      const config = {};
      config.allowServerErrors = true;
      return $http.get(`bs-center/${bsId}/default-photo/`, config)
        .then(response => response.data);
    },

    // http://swagger.dev.cian.ru/?url=http://www.master.dev.cian.ru/swagger/addform_common.json#!/geo/get_addform_v2_roads
    roads: (query, config) => {
      config = config || {};
      config.allowServerErrors = true;
      config.params = query;
      return $http.get('roads/', config)
        .then(response => response.data);
    },

    // http://swagger.dev.cian.ru/?url=http://www.master.dev.cian.ru/swagger/addform_common.json#!/geo/get_addform_v2_undergrounds
    undergrounds: (query, config) => {
      config = config || {};
      config.allowServerErrors = true;
      config.params = query;
      return $http.get('undergrounds/', config)
        .then(response => response.data)
        .then(data => {
          if (data.data && data.data.undergrounds) data.data.undergrounds.forEach(u => u.lineColor = u.lineColor || u.color);
          return data;
        });
    },

    // http://swagger.dev.cian.ru/?url=http://www.master.dev.cian.ru/swagger/addform_common.json#!/geo/get_addform_v2_jks
    jks: (config) => {
      const cnf = { ...config, allowServerErrors: true };

      return $http.get('jks/', cnf)
        .then(response => {
          // исправляем координаты
          if (response && response.data && response.data.data && response.data.data.jks) {
            response.data.data.jks.forEach(jk => {
              if (jk.geo && jk.geo.coordinates) swapLatLng(jk.geo.coordinates);
              if (jk.houses) {
                jk.houses.forEach(h => {
                  if (h.geo) {
                    if (h.geo.coordinates) swapLatLng(h.geo.coordinates);

                    // Копируем станции метро из родителя
                    h.geo.underground = [].concat(h.geo.underground, jk.geo.underground);
                  }
                });
              }
            });
          }
          return response;
        });
    },

    getNewbuildingById: config => {
      return $http.get('get-newbuilding-by-id/', config).then(response => {
        // исправляем координаты
        if (response && response.data && response.data.data && response.data.data.newbuilding) {
            const newbuilding = response.data.data.newbuilding;

            if (newbuilding.geo && newbuilding.geo.coordinates) swapLatLng(newbuilding.geo.coordinates);
            if (newbuilding.houses) {
              newbuilding.houses.forEach(h => {
                if (h.geo) {
                  if (h.geo.coordinates) swapLatLng(h.geo.coordinates);

                  // Копируем станции метро из родителя
                  h.geo.underground = [].concat(h.geo.underground, newbuilding.geo.underground);
                }
              });
            }
        }
        return response;
      });
    },

    // http://swagger.dev.cian.ru/?url=http://www.master.dev.cian.ru/swagger/addform_common.json#!/geo/get_addform_v2_geocode
    geocode: config => {
      const cnf = angular.extend(config, { allowServerErrors: true });
      return $http.get('geocode/', cnf);
    },

    // Метод для проверки статуса объявления (опубликова ли уже или в процессе)
    // Если сервер вернул ошибку от /offers, то начинаем поллить этот запрос,
    // потому что возможно это по таймауту отвалился третий сервис отвечающий за публикацию
    // Пока неясно, как отличать ситуации когда таймаут или реально ошибка на сервере
    // http://swagger.dev.cian.ru/?url=http://www.master.dev.cian.ru/swagger/addform_common.json#!/offer/get_addform_v2_offers_object_guid_status
    offerStatus: (offerId, config) => {
      return $http.get(`offers/${offerId}/status/`, config);
    },

    // http://swagger.dev.cian.ru/?url=http://www.master.dev.cian.ru/swagger/addform_common.json#!/offer/get_addform_v2_offers_object_guid
    getOffer: (offerId, data) => {
      return $http.post(`offers/${offerId}/`, data);
    },

    // http://swagger.dev.cian.ru/?url=http://www.master.dev.cian.ru/swagger/addform_common.json#!/offers/post_addform_v2_offers
    // allowServerErrors - флаг для идентификации запроса, для которого статус ошибка сервера является успешным
    // Принимает параметр geo.address в порядке ParentToChild (от региона к дому), например [регион, район, дом]
    // Объект в geo.address похож на locationPath.
    // Во всех остальных API отправляем locationPath в том же порядке,
    // в котором его получаем от геокодера, а именно ChildToParent.
    postOffer: (data, queryParams) => {
      return httpApi.fetch({
        apiType: 'legacy',
        assertStatusCodes: [200, 400],
        method: 'POST',
        microserviceName: 'monolithPython',
        pathApi: `/addform/v2/offers/${queryParams}`,
        hostType: 'ud-api',
        parameters: {
          ...data,
        },
      })
      .then(response => {
        if (response.statusCode === 200) {
          return response;
        }

        return $q.reject(response);
      });
    },

    // http://swagger.dev.cian.ru/?url=http://www.master.dev.cian.ru/swagger/addform_common.json#!/phone/post_addform_v2_phone
    verifyPhone: data => {
      return $http.post('phone/', data);
    },

    // http://swagger.dev.cian.ru/?url=http://www.master.dev.cian.ru/swagger/addform_common.json#!/phone/post_addform_v2_phone_validation_code
    sendValidationCode: data => {
      return $http.post('phone/validation-code/', data);
    },

    // http://swagger.dev.cian.ru/?url=http://www.master.dev.cian.ru/swagger/addform_common.json#!/user/get_addform_v2_user
    getUser: config => {
      return $http.get('user/', config);
    },

    // options:
    // category - категория объявления
    // isByHomeowner - true/false - собственник
    getTooltips: options => {
      const getApiHost = () => {
        switch (environment) {
          case 'local':
          case 'development':
            return 'http://master.addform-tooltips.dev3.cian.ru/public/v1';

          case 'beta':
            const betaName = window.location.host.match(/beta(\d+)/ig);

            return `https://${betaName}.addform-tooltips.stage.cian.ru/public/v1`;

          default:
            return 'https://api.cian.ru/addform-tooltips/v1';
        }
      }

      const apiHost = getApiHost();

      if (options.isByHomeowner) {
        options.isByHomeowner = true;
      } else {
        options.isByHomeowner = false;
      }

      const headers = {
        'Cache-Control': undefined,
        'Pragma': undefined,
      }

      return $http.get(`${apiHost}/get-category-tooltips/`, {params: options, headers});
    },

    // {offerId: number}
    sendAdvertiseRequest: data => {
      return $http.post(`send-free-professional-help-request/`, data);
    },

    socialLogin: data => {
      let jsonpCounter = 0;
      const jsonpRequest = config => {
        return new Promise((resolve, reject) => {
          const hash = `_jsonpCallback${jsonpCounter++}`;

          const script = document.createElement('script');
          script.async = true;
          script.src = config.url.indexOf('?') >= 0
            ? `${config.url}&_=${Math.random()}&callback=${hash}`
            : `${config.url}?_=${Math.random()}&callback=${hash}`;
          script.onerror = (e) => {
            reject(e);
          };

          window[hash] = data => {
            document.head.removeChild(script);
            delete window[hash];
            resolve(data);
          };

          document.head.appendChild(script);
        });
      };

      const promiseSeries = tasks => {
        return tasks.reduce((acc, task) => {
          return acc.then(() => {
            return task();
          });
        }, Promise.resolve());
      };

      const getAuthCookies = (logOnInfo, login) => {
        return jsonpRequest({
          url: `${logOnInfo.logOnUrl}?` +
          `login=${encodeURIComponent(login)}&` +
          `token=${logOnInfo.token}&` +
          `persistent=true`,
        });
      };

      const logOn = (logOnInfoItems, email) => {
        return promiseSeries(logOnInfoItems.map(logOnInfoItem => {
          return () => getAuthCookies(logOnInfoItem, email);
        }));
      };

      return $http.post('/api/users/v1/social-validate/', data)
        .then(body => {
          const result = body.data;
          return logOn(result.logOnInfo, data.email);
        });
    },

    socialMerge: data => {
      return $http.post('/api/users/v1/social-merge-existed/', data)
    },

    socialMergeNew: data => {
      return $http.post('/api/users/v1/social-merge-new/', data)
    },

    generateFakeEmail: data => {
      return $http.post('/api/users/v1/social-generate-email', data)
    },

    // http://swagger.dev.cian.ru/?url=http://master.realty.test.dmir.ru/swagger/#!/UsersRegistrationWebApi/UsersRegistrationWebApi_Register
    registerUser: data => {
      return $http.post('/api/users/register/', data);
    },

    // http://swagger.dev.cian.ru/?url=http://master.dev.cian.ru/swagger/api.json#!/registration/post_cian_api_site_v1_user_quick_register
    registerUserSimple: data => {
      return $http.post('/cian-api/site/v1/user-quick-register/', data);
    },

    // http://swagger.dev.cian.ru/?url=http://www.master.dev.cian.ru/swagger/addform_common.json#!/user/post_addform_v2_user_password
    restorePassword: data => {
      return $http.post('user/password/', data);
    },

    // Проверка, можно ли пользователю размещать объявление с его тарифом
    // http://swagger.dev.cian.ru/?url=http://www.master.dev.cian.ru/swagger/addform_common.json#!/offer95publish/get_addform_v2_is_service_available
    checkServiceAvailability: config => {
      return $http.get('is-service-available/', config);
    },

    // http://swagger.dev3.cian.ru/?url=http://master.demand.dev3.cian.ru/swagger/
    createMessageFromAddform: data => {
      const getApiHost = () => {
        switch (environment) {
          case 'local':
          case 'development':
            return 'http://master.demand.dev3.cian.ru/public/v2';

          case 'beta':
            const betaName = window.location.host.match(/beta(\d+)/ig);

            return `https://${betaName}.demand.stage.cian.ru/public/v2`;

          default:
            return 'https://api.cian.ru/demand/v2';
        }
      };

      return $http.post(
        `${getApiHost()}/create-message-for-addform/`,
        data,
        { withCredentials: true, allowServerErrors: true },
      );
    },

    // Данные о ценах на тарифы
    // http://swagger.dev.cian.ru/?url=http://www.master.dev.cian.ru/swagger/addform_common.json#!/offer95publish/get_addform_v2_publish_packages
    getTariffPrices: config => {
      return $http.get('publish-packages/', config);
    },

    getRegionName: locationId => {
      return $http.get(`region/?locationId=${locationId}`);
    },

    addJK: data => {
      return $http.post('add-jk/', data, { allowServerErrors: true });
    },

    getPriceEstimate: (request, config) => {
      return $http.post('/estimator/ajax/estimate-with-rent/', request, config).then(response => response && response.data && response.data.data ? response.data.data : {});
    },

    // http://announcementapi.cian.ru/swagger/ui/index#!/Price/Price_GetMinPrice
    getPriceLimit: (request, config) => {
      const getApiHost = () => {
        switch (environment) {
          case 'local':
          case 'development':
            return 'http://master.dev3.cian.ru/addform/v3';

          case 'beta':
            const betaName = window.location.host.match(/beta(\d+)/ig);

            return `https://www.${betaName}.stage.cian.ru/addform/v3`;

          default:
            return 'https://api.cian.ru/addform/v3';
        }
      };

      return $http.post(`${getApiHost()}/get-min-price/`, request, config).then(response => response && response.data ? response.data : {});
    },

    // http://swagger.dev.cian.ru/?url=http://www.master.dev.cian.ru/swagger/addform_common.json#!/bs95centers/get_addform_v2_bs_center_id_default_photo
    getBSCenters: (params, config = {}) => {
      config.params = params;
      return $http.get('bs_centers/', config)
        .then(response => {
          if (!response.data || !response.data.data || !response.data.data.bs_centers)
            throw new Error('bsCenterService: wrong response format');
          return response.data;
        });
    },

    // http://master.bill.test.cian.ru/swagger/ui/index#!/AnnouncementWebApi/AnnouncementWebApi_GetMinimalImagesCount
    getMinPhotoCount: (request, config) => {
      config = config || {};
      config.params = request;
      return $http.get('/cian-api/site/v1/get-minimal-images-count/', config)
        .then(response => response.data);
    },

    /**
     * Узнать возможна ли публикация для данного пользователя в конкретной категории и регионе
     */
    getPubAvail: (parameters) => {
      const model = {
        apiType: 'public',
        assertStatusCodes: [200, 400],
        method: 'GET',
        microserviceName: 'billingTariffs',
        pathApi: '/v2/announcement/get-publication-availability-popup/',
        parameters,
      };

      const requestConfig = {
        withCredentials: true,
      };

      return httpApi.fetch(model, { requestConfig })
        .then(({ response }) => {
          if (response && response.windowModeType) {
            response.windowModeType = response.windowModeType.replace(/Iden\w+fication/g, 'Identification');
          }

          return response;
        });
    },

    sendTarif: (phoneNumber, tariff, offerId) =>
      $http.post(
        `${window.runtime_settings.dealRentBaseUrl}/v1/save-selected-tariff/`,
        {phoneNumber, tariff, offerId},
        {withCredentials: true}
    ),

    /*
    http://swagger.dev.cian.ru/?url=http://master.dev.cian.ru/swagger/bti.json#!/buildings/get_cian_api_site_v1_bti_buildings
    */
    getBtiBuildings: (buildingId) => {
      return httpApi.fetch({
        apiType: 'public',
        assertStatusCodes: [200],
        method: 'GET',
        microserviceName: 'bti',
        pathApi: '/v1/get-bti-data-addform/',
        parameters: {
          houseId: buildingId,
        },
      })
        .then(({ response, statusCode }) => {
          if (statusCode === 200) {
            /**
             * Если каждое свойство равно null, значит данных нет
             * Актуально только на деве
             * @type {[type]}
             */
            const everyIsNull = Object.values(response).every((value) => value === null);

            if (everyIsNull) {
              return $q.reject();
            }

            return response;
          }

          return $q.reject();
        });
    },

    /**
     * Получение данных о заявках по текущему пользователю
     * Пример ответа {"status": "ok", "data": {"isMessagingEnabled": true}}
     */
    getMessagingSettings: () => {
      // return $timeout(() => {
      //    return {"isMessagingEnabled": isMessagingEnabled}
      // }, 1000);

      return $http.get('messages/get-data-message-user/')
        .then(response => {
          if (!response.data || !response.data.data) {
            throw new Error('GetMessagingSettings: неправильный формат ответа');
          }
          return response.data.data;
        });
    },

    /**
     * Получение настроек для фрейма оплаты Яндекс.Кассы
     */
    getYandexFrameSettings: (amount) => {
      const apiHost = environment === 'beta' || environment === 'production' ?
        'https://api.cian.ru/billing-payments/v1' :
        'http://master.billing-payments.dev3.cian.ru/public/v1';

      return $http.get(`${apiHost}/payment-systems/get-settings`,
        { params: { amount, paymentSystem: 'iframeCard' }, withCredentials: true }
      )
        .then((response) => {
          if (!response.data || !response.data.settings) {
            throw new Error('Неправильный запрос');
          }

          return response.data.settings;
        });
    },

    /**
     * Получение статуса платежа через Яндекс.Кассу
     */
    getYandexPaymentStatus: (clientOrderId) => {
      const apiHost = environment === 'beta' || environment === 'production' ?
        'https://api.cian.ru/billing-payments/v1' :
        'http://master.billing-payments.dev3.cian.ru/public/v1';

      return $http.get(`${apiHost}/check-payment`, { params: { clientOrderId }, withCredentials: true })
        .then((response) => {
          if (!response.data || response.data.paymentProcessed === undefined) {
            throw new Error('Неправильный запрос');
          }

          return response.data.paymentProcessed;
        });
    },

    /**
     * Получение баланса пользователя
     */
    getUserBalance: () => {
      const apiHost = environment === 'beta' || environment === 'production' ?
        'https://api.cian.ru/billing-accounts/v1' :
        'http://master.billing-accounts.dev3.cian.ru/public/v1';

      return $http.get(`${apiHost}/get-user-balance`, { withCredentials: true })
        .then((response) => {
          if (!response.data) {
            throw new Error('Неправильный запрос');
          }

          return response.data;
        });
    },

    addObjectRequest: (request, config) => {
      return $http.post('/addform/v1/add-object-request/', request, config);
    },

    /**
     * Получить саджесты для поля Возможное назнаечение
     * @param  {string} term подстрока для поиска
     * @param {Promise} timeout промис, через который отменяем запрос
     * @return {Promise}
     */
    getSpecialties: (term, timeout) => {
      return $http.get('/cian-api/site/v1/get-specialties/', {params: {term}, timeout})
        .then(response => {
          const specialties = get(response, 'data.data.specialties');
          if (!specialties) {
            throw new Error('getSpecialties: неправильный формат ответа');
          }

          return specialties;
        });
    },

    /**
     * Нужно ли показывать пользователю галку Я - собственник
     * http://swagger.dev.cian.ru/?url=http://www.master.dev.cian.ru/swagger/addform_common.json#!/offer95publish/get_addform_v2_user_can_publish_as_homeowner
     */
    canPublishAsHomeowner: config => {
      return $http.get('user/can-publish-as-homeowner/', config)
        .then(res => {
          if (res.data.status === 'ok') {
            return res.data.data.canPublishAsHomeowner;
          } else {
            return $q.reject();
          }
        })
    },

    /**
     * Смена условий размещения для объявления
     * Используется для докупки ВЦ
     * http://swagger.dev.cian.ru/?url=http://master.dev.cian.ru/swagger/api.json#!/offers/post_ajax_publish_offer
     */
    ajaxPublishOffer: (request, config) => {
      return $http.post('/ajax/publish-offer/', request, config).then(res => {
        // Даже в случае ошибки бэк возвращает статус 200
        if (has(res, 'data.errorCode')) {
          return $q.reject(res);
        }

        return res;
      });
    },

    /**
     * http://master.customer.dev.cian.ru/1.0/data/get_available_services/?regionId=1
     */
    lkGetAvailableServices: (regionId) => {
      return $http.get(getLkLink('1.0/data/get_available_services/'), {params: {regionId}, withCredentials: true})
        .then(lkResponseNormalizer('get_available_services'));
    },

    lkGetPriceInfo: (params) => {
      return $http.get(getLkLink('1.0/data/get_price_info/'), {params, withCredentials: true})
        .then(lkResponseNormalizer('get_price_info'));
    },

    lkAddServicePackages: (request) => {
      return $http.post(getLkLink('1.0/add_service_packages/'), request, {withCredentials: true})
        .then(lkResponseNormalizer('add_service_packages'));
    },

    lkServicePackagesGetStatus: config => {
      const requestConfig = {
        withCredentials: true,
        ...config,
      };

      return $http.get(getLkLink('1.0/data/service_packages_get_status'), requestConfig)
        .then(lkResponseNormalizer('service_packages_get_status'));
    },

    /**
     * Получение гео данных пользователя после логина
     */
    getUserGeo: () => {
      return $http.get('/cian-api/site/v1/get-user-geo/');
    },

    /**
     * Получение информации о ЖК по его ID
     */
    getNewobjectInfo: newobjectId => {
      return $http.get('/cian-api/site/v1/get-newobject-info/', {params: {newobjectId}});
    },

    /**
     * http://swagger.dev.cian.ru/?url=http://master.dev.cian.ru/swagger/addform_common.json#!/registration/get_addform_v1_registration_check_email
     * Варианты ответов:
     * {"status": "ok", "data": {"status": "ok"}}
     * {"status": "ok", "data": {"status": "emailAlreadyExists"}}
     * {"status": "ok", "data": {"status": "invalidEmail"}}
     */
    checkEmail: config => {
      return $http.get('registration/check-email/', config);
    },

    /**
     * http://swagger.dev.cian.ru/?url=http://master.dev.cian.ru/swagger/addform_common.json#!/registration/post_addform_v2_registration_send_phone_confirm_code
     * Положительный ответ:
     * 204 no content
     *
     * Ошибка:
     * 400
     *  {
     *    "message": "Номер телефона имеет неверный формат",
     *    "errors": [
     *      {
     *        "key": null,
     *        "message": "Номер телефона имеет неверный формат",
     *        "code": null
     *      }
     *    ],
     *    "params": {
     *      "apiName": "send-confirm-code",
     *      "models": [
     *        {
     *          "key": "request",
     *          "value": {
     *            "phoneNumber": "+dd"
     *          }
     *        }
     *      ]
     *    }
     *  }
     */
    sendPhoneConfirmCode: (phoneNumber) => {
      return $http.post('registration/send-phone-confirm-code/', {phoneNumber});
    },

    /**
     * http://swagger.dev.cian.ru/?url=http://master.dev.cian.ru/swagger/addform_common.json#!/registration/post_addform_v2_registration_validate_phone_confirm_code
     * Положительный ответ:
     * 204 no content
     *
     * Ошибка:
     * 400
     *  {
     *    "message": "Номер телефона имеет неверный формат",
     *    "errors": [
     *      {
     *        "key": null,
     *        "message": "Номер телефона имеет неверный формат",
     *        "code": null
     *      }
     *    ],
     *    "params": {
     *      "apiName": "validate-confirm-code",
     *      "models": [
     *        {
     *          "key": "request",
     *          "value": {
     *            "phoneNumber": "1234",
     *            "confirmationCode": "1234"
     *          }
     *        }
     *      ]
     *    }
     *  }
     *
     * Другая ошибка:
     * 400
     *  {
     *    "message": "Неверный код подтверждения",
     *    "errors": [
     *      {
     *        "key": null,
     *        "message": "Неверный код подтверждения",
     *        "code": null
     *      }
     *    ],
     *    "params": {
     *      "apiName": "validate-confirm-code",
     *      "models": [
     *        {
     *          "key": "request",
     *          "value": {
     *            "phoneNumber": "+79999816256",
     *            "confirmationCode": "1234"
     *          }
     *        }
     *      ]
     *    }
     *  }
     */
    validatePhoneConfirmCode: (data, config) => {
      return $http.post('registration/validate-phone-confirm-code/', data, config);
    },

    /**
     * Положительный ответ:
     * {"value":"Success","message":null}
     *
     * Ошибка:
     * 200
     * {
     *  "value": "PasswordError",
     *  "message": "Пароль должен содержать не менее 6 символов, в том числе цифры, строчные и заглавные буквы"
     * }
     *
     * Другая ошибка:
     * 200
     * {
     *  "message": "Parameter Password was empty"
     * }
     */
    validatePassword: (password, config) => {
      return $http.post('/cian-api/site/v1/validate-password/', {password}, {...config, allowServerErrors: true});
    },

    /**
     * Премодерация ML по явным нарушениям.
     * https://cianru.atlassian.net/browse/PM-3644
     *
     * Успех:
     * 204 No content
     *
     * Найдены нарушения:
     * 400
     * В заголовке передаётся хеш операции, который надо передавать при последующих вызовах.
     * В теле ответа содержится список ошибок.
     */
    premoderationCheck: (ad, params) => {
      return $http.post('validate-visible-violations/', ad, params);
    },

    /**
     * http://swagger.dev3.cian.ru/?url=https://bitbucket.org/!api/2.0/snippets/semyon_fedotov/oebojp/12859220ad889ac294d2a3e42d9edf0e08b7f03e/files/ivr_api
     */
    needPopupForIvr: (data) => {
      const getApiHost = () => {
        switch (environment) {
          case 'local':
          case 'development':
            return 'http://master.moderation-onboarding.dev3.cian.ru/public/v1';

          case 'beta':
            const betaName = window.location.host.match(/beta(\d+)/ig);

            return `https://${betaName}.moderation-onboarding.stage.cian.ru/public/v1`;

          default:
            return 'https://api.cian.ru/moderation-onboarding/v1';
        }
      }

      return $http.post(`${getApiHost()}/need-onboarding-ivr/`, data, {withCredentials: true, allowServerErrors: true});
    },

    /**
     * Получение списка саджеста для привязки КП к объявлению
     * Если name не указан, то должен быть locations
     * @param {Object} [props={}]
     * @param {string} [props.name] имя КП, введённое пользователем
     * @param {number} [props.regionId]
     * @param {Object[]} [props.locations]
     * @param {numebr} props.locations[].id
     * @param {numebr} props.locations[].type_id
     */
    getVillageSuggests: ({ name, regionId, locations } = {}) => {
      const getApiHost = () => {
        switch (environment) {
          case 'local':
          case 'development':
            return 'http://master.countryside-search.dev3.cian.ru/public';

          case 'beta':
            const betaName = window.location.host.match(/beta(\d+)/ig);

            return `https://${betaName}.countryside-search.stage.cian.ru/public`;

          default:
            return 'https://api.cian.ru/countryside-search';
        }
      }

      if (name) {
        return $http.get(`${getApiHost()}/v1/get-village-suggests/`, {
          params: {
            name,
            regionId,
          },
          headers: {
            'Cache-Control': undefined,
            'Pragma': undefined,
          },
          withCredentials: true,
        }).then(response => response.data.suggests)
      } else {
        return $http.post(`${getApiHost()}/v1/get-village-suggests-by-locations/`, {
          locations,
        }, {
          headers: {
            Accept: undefined,
            'Content-Type': undefined
          },
          withCredentials: true,
        }).then(response => response.data.suggests);
      }

    },

    getValuationEstimate (houseId, area, roomsCount) {
      const getApiHost = () => {
        switch (environment) {
          case 'local':
          case 'development':
            return 'http://master.price-estimator.dev3.cian.ru/public/v1/get-estimation-price-addform-desktop/';

          case 'beta':
            const betaName = window.location.host.match(/beta(\d+)/ig);

            return `https://${betaName}.api.stage.cian.ru/price-estimator/v1/get-estimation-price-addform-desktop/`;

          default:
            return 'https://api.cian.ru/price-estimator/v1/get-estimation-price-addform-desktop/';
        }
      }

      if (Boolean(houseId) && Boolean(area) && Boolean(roomsCount)) {
        return $http.get(
          `${getApiHost()}?area=${area}&roomsCount=${roomsCount}&houseId=${houseId}`,
          {
            headers: {
              'Pragma': undefined,
              'Cache-Control': undefined,
            },
          },
        )
      } else {
        return Promise.reject('Wrong params');
      }
    },
  };
};
